/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/WinAnimators/KaleidoscopeWinAnimator',['pixi',
        'proton',
        'absolute/particleemitter',
        'absolute/coords',
        'CardUI/WinAnimators/BaseWinAnimator',
        'Arkadium/GameEngine/Scenes/Nodes/SceneNode',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Maths/Vector2',
        'Arkadium/GameEngine/Maths/Bezier2D',
        'Arkadium/GameEngine/Tween/Tween',
        'Arkadium/GameEngine/Core/EngineManagers',
        'absolute/audiomanager'
    ],
    function (PIXI, Proton, ParticleEmitter, Coords, BaseWinAnimator, SceneNode, SpriteNode, Vector2, Bezier2D, Tween, EngineManagers, AudioManager) {
        "use strict";

        var AnimationStateEnum =
        {
            None: 0,
            SpawnCards: 1,
            Done: 2
        };

        var KaleidoscopeWinAnimator = function (supplyView) {
            this.initKaleidoscopeWinAnimator(supplyView);
        };

        KaleidoscopeWinAnimator.prototype = Object.create(BaseWinAnimator.prototype);
        KaleidoscopeWinAnimator.prototype.constructor = KaleidoscopeWinAnimator;


        KaleidoscopeWinAnimator.prototype.initKaleidoscopeWinAnimator = function (supplyView) {
            BaseWinAnimator.call(this, supplyView);

            this._foggingBackground = null;
            this._pileView = null; /* PileView */
            this._glow = null; /* SpriteNode */
            this._animationState = AnimationStateEnum.None; /* AnimationStateEnum */

            this._numberOfCardsFallen = 0; /* int */
            this._numberOfCardsFinished = 0; /* int */
            this._totalNumberOfCards = 0; /* int */
            this._cardSpawnDelay = 0.0; /* float */
            this._glowStarted = false; /* bool */
            this._pilesCount = 0; /* int */
        };

        KaleidoscopeWinAnimator.prototype.ShouldStartDuringCardMovement = function () /* bool */
        {
            return false;
        };

        KaleidoscopeWinAnimator.prototype.BeginAnimation = function (/* Action */ endAnimationCallback, /* Card */ lastCardDropped, /* Pile */ lastPileDroppedOnto, /* bool */ dragging)
        {
            this._numberOfCardsFallen = 0;
            this._numberOfCardsFinished = 0;
            this._totalNumberOfCards = this.SupplyView.CardSupply.GetCardList().length;
            this._cardSpawnDelay = 0.4;

            this._animationState = AnimationStateEnum.SpawnCards;


            AudioManager.playSound('winKaleidoscope');

            BaseWinAnimator.prototype.BeginAnimation.call(this, endAnimationCallback, lastCardDropped, lastPileDroppedOnto, dragging);


            this.carousel9 = this.addCarousel(9, 1, 0x9999FF, 1.5);
            this.carousel18 = this.addCarousel(26, 1, 0xFF9999, 1.4);
            this.carousel1 = this.addCarousel(1, -1, 0xFFFFFF, 0.4);
            this.carousel8 = this.addCarousel(8, 1, 0xFFFFFF, 1);
            this.carousel32 = this.addCarousel(32, 1, 0xFFFFFF, 0.6);
            this.carousel30 = this.addCarousel(28, 1, 0xFFFFFF, 1.4);

        };

        KaleidoscopeWinAnimator.prototype.addCarousel = function (maxCards, direction, tint, scale)
        {
            direction = direction || 1;
            tint = tint || 0xFFFFFF;
            scale = scale || 1;
            var carousel = new Carousel(maxCards, direction, tint);
            this.AnimationContainer.AddChild(carousel);
            carousel.position.set(EngineManagers.Display.Width / 2, EngineManagers.Display.Height / 2);
            carousel.scale.set(scale, scale);
            carousel.spin();

            return carousel;
        };

        KaleidoscopeWinAnimator.prototype.OnSizeChanged = function (/* object */ sender, /* WindowSizeChangedEventArgs */ e)
        {
            this.FinishEndingAnimation();
        };

        KaleidoscopeWinAnimator.prototype.UpdateEndingAnimation = function (/* object */ o, /* EventArgs */  time)
        {
            if (this._hasUserClicked)
            {
                this.FinishEndingAnimation();
                return;
            }

            if (this._numberOfCardsFinished >= this._totalNumberOfCards)
            {
                this._animationState = AnimationStateEnum.Done;
            }


            if (this._animationState == AnimationStateEnum.SpawnCards)
            {
                this._animationState = AnimationStateEnum.None;
                var /* CardView */ card;
                if (this.SupplyView.CardSupply.GetCardList().length > 52)
                {
                    var /* Pile */ pile = this.SupplyView.CardSupply.GetPile("Foundation" + (this._numberOfCardsFallen % 8));
                    card = this.SupplyView.GetCardView(pile.NthFromTop(Math.floor(1 + this._numberOfCardsFallen / 8)));
                }
                else
                {
                    var /* Pile */ pile = this.SupplyView.CardSupply.GetPile("Foundation" + (this._numberOfCardsFallen % 4));
                    card = this.SupplyView.GetCardView(pile.NthFromTop(Math.floor(1 + this._numberOfCardsFallen / 4)));
                }

                /*
                var spinCardNode = new SpinCardNode(this, card);
                this.AnimationContainer.AddChild(spinCardNode);
                spinCardNode.TriggerSpawn(this._numberOfCardsFallen);
                card.Animating = true;
                //card.Visible = false;
                this._numberOfCardsFallen++;
                */
                var getNextTexture = function (num) {
                    var texturePath = "";
                    switch (num % 3) {
                        case 0:
                            texturePath = this.SupplyView.GetThemeAssetPath("kh");
                            break;
                        case 1:
                            texturePath = this.SupplyView.GetThemeAssetPath("qh");
                            break;
                        case 2:
                            texturePath = this.SupplyView.GetThemeAssetPath("jh");
                            break;
                    }
                    return texturePath;
                }.bind(this);

                switch (this._numberOfCardsFallen)
                {
                    case 10:
                        this._cardSpawnDelay -= 0.1;
                        break;
                    case 25:
                        this._cardSpawnDelay -= 0.1;
                        break;
                }

                if (!this.carousel8.full) {
                    this.carousel8.addCard(card.CardFront.sprite.texture, card.toGlobal(card.position));
                    card.parent.removeChild(card);
                    this._numberOfCardsFallen++;
                }
                else if (!this.carousel32.full) {

                    if (!this.carousel1.full) {
                        var c = this.SupplyView.GetCardView(pile.Bottom);
                        this.carousel1.addCard(c.CardFront.sprite.texture, c.toGlobal(c.position), true);
                    }

                    if (!this.carousel9.full) {
                        this.carousel9.addCard(PIXI.Texture.fromFrame(getNextTexture(this.carousel9.numCards)), new PIXI.Point(EngineManagers.Display.Width / 2, -EngineManagers.Display.Height / 2));
                    }

                    if (!this.carousel18.full) {
                        this.carousel18.addCard(PIXI.Texture.fromFrame(getNextTexture(this.carousel18.numCards)), new PIXI.Point(EngineManagers.Display.Width / 2, -EngineManagers.Display.Height / 2));
                    }

                    if (!this.carousel30.full) {
                        this.carousel30.addCard(PIXI.Texture.fromFrame(getNextTexture(this.carousel30.numCards)), new PIXI.Point(EngineManagers.Display.Width / 2, -EngineManagers.Display.Height / 2));
                    }

                    this.carousel32.addCard(card.CardFront.sprite.texture, card.toGlobal(card.position));
                    card.parent.removeChild(card);
                    this._numberOfCardsFallen++;
                } else {
                    this._animationState = AnimationStateEnum.Done
                }

                // Wait the prescribed amount of time before transitioning back into SpawnCards state to spawn the next card
                if (this._numberOfCardsFallen < this._totalNumberOfCards)
                {
                    Tween.Start(this.SupplyView).Wait(this._cardSpawnDelay).Then().Call(function () { this._animationState = AnimationStateEnum.SpawnCards; }.bind(this));
                }

            }
            if (this._animationState == AnimationStateEnum.Done)
            {
                this._animationState = AnimationStateEnum.None;
                Tween.Start(this.SupplyView.GameContainer).Wait(2).Then().Call(this.FinishEndingAnimation.bind(this));
            }
        };

        KaleidoscopeWinAnimator.prototype.FinishEndingAnimation = function ()
        {
            if (!this._hasAnimationStarted) return;

            AudioManager.stopSound('winKaleidoscope');

            for (var i = 0; i < this._pilesCount; i++)
            {
                this._pileView = this.SupplyView.GetPileView("Foundation" + i);
                this._pileView.removeChildAt(0);
            }

            this.carousel9.destroy();
            this.carousel18.destroy();
            this.carousel1.destroy();
            this.carousel8.destroy();
            this.carousel32.destroy();
            this.carousel30.destroy();

            this.AnimationContainer.removeChild( this.carousel9);
            this.AnimationContainer.removeChild( this.carousel18);
            this.AnimationContainer.removeChild( this.carousel1);
            this.AnimationContainer.removeChild( this.carousel8);
            this.AnimationContainer.removeChild( this.carousel32);
            this.AnimationContainer.removeChild( this.carousel30);

            BaseWinAnimator.prototype.FinishEndingAnimation.call(this);
        };

        KaleidoscopeWinAnimator.prototype.IsAnimationRunning = function () /* bool */
        {
            return this._hasAnimationStarted && !this._hasUserClicked &&  this._numberOfCardsFinished < this._totalNumberOfCards;
        };

        KaleidoscopeWinAnimator.prototype.DidStartAnimation = function () /* bool */
        {
            return this._hasAnimationStarted;
        };

        KaleidoscopeWinAnimator.prototype.ShouldShowEndingPopup = function () /* bool */
        {
            return this._hasAnimationStarted && (this._hasUserClicked || this._numberOfCardsFinished >= this._totalNumberOfCards);
        };

        KaleidoscopeWinAnimator.prototype.StopAnimationPointEvent = function (/* PointEvent */ pointEvent)
        {
            this.DoClickEnding();
        };

        KaleidoscopeWinAnimator.prototype.StopAnimationKeyEvent = function (/* KeyboardEvent */ keyboardEvent)
        {
            /*
             TODO
             if (keyboardEvent.Key == VirtualKey.Enter && keyboardEvent.Pressed)
             {
             DoClickEnding();
             }
             */
        };

        KaleidoscopeWinAnimator.prototype.DoClickEnding = function ()
        {
            if (this._animationState == AnimationStateEnum.None)
            {
                this._hasUserClicked = true;
            }
        };

        KaleidoscopeWinAnimator.prototype.IncrementNumberCardsFinished = function ()
        {
            this._numberOfCardsFinished++;
        };


        var Carousel = function (maxCards, direction, tint) {
            this.initCarousel(maxCards, direction, tint);
        };

        Carousel.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);
        Carousel.prototype.constructor = Carousel;

        Carousel.prototype.initCarousel = function (maxCards, direction, tint) {
            PIXI.DisplayObjectContainer.call(this);
            this.maxCards = maxCards;
            this.direction = direction || 1;
            this.tint = tint || 0xFFFFFF;
            this.cardSprites = [];
            this.container = new PIXI.Sprite();
            this.addChild(this.container);
            this.container.anchor.set(0.5, 0.5);


            var self = this;
            this.spinTween = new TWEEN.Tween({rotation: self.container.rotation})
                .easing(TWEEN.Easing.Linear.None)
                .to({rotation: this.rotation + Math.PI * 2}, 4000)
                .onUpdate(function(){
                    self.container.rotation = self.direction * this.rotation;
                })
                .onComplete(function(){
                })
                .repeat(100);
        };

        Carousel.prototype.destroy = function () {
            TWEEN.remove(this.startTween);
            TWEEN.remove(this.spinTween);
            this.removeChild(this.container);
            this.container = null;
        };

        Carousel.prototype.spin = function () {
            this.spinTween.start();
        };

        Carousel.prototype.addCard = function (texture, globalPosition, fade) {
            var cardSprite = new PIXI.Sprite(texture);
            cardSprite.scale.x = cardSprite.scale.y = 0.9 / this.scale.x;
            cardSprite.anchor.set(0.5, 0.5);
            cardSprite.tint = this.tint;
            this.cardSprites.push(cardSprite);

            var r = this.scale.x * (this.maxCards * cardSprite.width) / (2 * Math.PI),
                theta = (Math.PI * 2) - ((this.cardSprites.length - 1) * (Math.PI * 2) / this.maxCards),
                endX = Math.cos(theta - (Math.PI / 2)) * (r + cardSprite.height / 4),
                endY = Math.sin(theta - (Math.PI / 2)) * (r + cardSprite.height / 4);

            if (this.maxCards == 1) {
                endX = 0;
                endY = 0;
            }

            var pos = this.container.toLocal(globalPosition);

            cardSprite.position.set(pos.x, pos.y);

            this.container.addChild(cardSprite);

            if (fade) {
                cardSprite.position.set(endX, endY);
                cardSprite.scale.set(0.9, 0.9);
                cardSprite.alpha = 0;
                cardSprite.rotation = theta;
                this.startTween = new TWEEN.Tween({alpha: 0})
                    .easing(TWEEN.Easing.Cubic.InOut)
                    .to({alpha: 1}, 1000)
                    .onUpdate(function () {
                        cardSprite.alpha = this.alpha;
                    }).onComplete(function () {
                    })
                    .start();
            }
            else {
                this.startTween = new TWEEN.Tween({x: cardSprite.x, y: cardSprite.y, rotation: cardSprite.rotation, scale: cardSprite.scale.x})
                    .easing(TWEEN.Easing.Cubic.InOut)
                    .to({x: endX, y: endY, rotation: theta, scale: 0.9}, 1000)
                    .onUpdate(function () {
                        cardSprite.x = this.x;
                        cardSprite.y = this.y;
                        cardSprite.rotation = this.rotation;
                        cardSprite.scale.set(this.scale, this.scale);
                    }).onComplete(function () {
                    })
                    .start();
            }
        };

        Object.defineProperty(Carousel.prototype, "full", {
           get: function () {
               return this.maxCards == this.cardSprites.length;
           }
        });

        Object.defineProperty(Carousel.prototype, "numCards", {
            get: function () {
                return this.cardSprites.length;
            }
        });


        return KaleidoscopeWinAnimator;
    });
